<template>
  <v-dialog v-model="dialog" max-width="900" persistent>
    <v-form lazy-validation v-model="valid" ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            checklist ? "List Of Kasbon Checked" : "List Of Kasbon Approved"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-row v-if="!loading">
            <v-col cols="12" class="mt-2">
              <v-data-table
                :headers="headers"
                :items="items"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.no="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.kasbonDate="{ item }">
                  {{ formatDate(item.kasbonDate) }}
                </template>
                <template v-slot:item.bankAccountNumber="{ item }">
                  {{ accountNumber(item) }}
                </template>
                <template v-slot:item.totalAmount="{ item }">
                  {{ formatPrice(item.totalAmount) }}
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" v-if="!checklist && !hasPinCookies">
              <v-text-field
                outlined
                dense
                flat
                background-color="white"
                v-model="pin"
                label="Pin"
                persistent-hint
                hint="Masukan PIN yang diperoleh dari APP"
                :rules="[v => !!v || 'Pin is required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="fill-height" align-content="center" justify="center" v-if="loading">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Processing transfer bank, please wait...
            </v-col>
            <v-col cols="6">
              <v-progress-linear indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close" :disabled="loading" class="mr-2">
            Close
          </v-btn>
          <v-btn
            v-if="$rbac.can('kasbon-general.create')"
            color="primary"
            @click="save"
            :disabled="loading"
          >
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from "moment";
import cookies from "@/services/cookies";
export default {
  name: "dialog-confirmation",
  props: {
    dialog: Boolean,
    items: Array,
    checklist: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: true,
      pin: "",
      hasPinCookies: false,
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Date",
          value: "kasbonDate",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 4,
          text: "Kasbon Number",
          value: "kasbonNumber",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Kasbon Name",
          value: "name",
          sortable: false,
          align: "start",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 6,
          text: "Method",
          value: "payment",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Bank Account Number",
          value: "bankAccountNumber",
          sortable: false,
          align: "start",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 7,
          text: "Total",
          value: "totalAmount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 7,
          text: "Created Date",
          value: "createdAt",
          sortable: true,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    checkPinCookies() {
      this.hasPinCookies = cookies.checkCookies();
      if (this.hasPinCookies) {
        this.pin = cookies.getCookies();
      }
    },
    save() {
      if (this.checklist) {
        this.$emit("save", this.items);
        return;
      }

      if (this.hasPinCookies) {
        this.$emit("save", { body: this.items, pin: this.pin });
      } else {
        if (this.$refs.form) {
          const isFormValid = this.$refs.form.validate();

          if (isFormValid) {
            cookies.generateCookies(this.pin);
            this.$emit("save", { body: this.items, pin: this.pin });
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Form validation failed. Please input pin",
            });
          }
        } else {
          this.$store.dispatch("toast", {
            type: "error",
            message:
              "Error: Could not find this.$refs.form. The form element might not be rendered in the DOM.",
          });
        }
      }
    },
    close() {
      this.$emit("close");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-yyyy");
    },
    accountNumber(item) {
      if (item.external) {
        return item.externalAccountNumber.accountNumber;
      } else {
        return item.bankAccountNumber;
      }
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.checkPinCookies();
      }
    },
  },
};
</script>

<style></style>
